'use strict';

var helper = require('../helper');

module.exports = {

    pushFindStoreFindInteraction (zipCode, sku, when) {
        if (!zipCode) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '24',
            'eventname': 'store_locator_search',
            'action': 'search',
            'search_term': helper.formatString(zipCode),
            'product_id': sku,
            'type': when
        };

        helper.log('Pushing find store impression for ' + zipCode + '!', true);
        helper.push(pushObject);
    },

    pushFindStoreGeolocationImpression (location, sku, when) {
        if (!location) {
            return;
        }
        location = helper.formatString(location);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '25',
            'eventname': 'store_locator_search',
            'action': 'geolocalize',
            'search_term': location,
            'product_id': sku,
            'type': when
        };

        helper.log('Pushing find store geolocation impression for ' + location + '!', true);
        helper.push(pushObject);
    },

    pushFindStoreClickResultAction (action, storeName, sku, where) {
        if (!action || !storeName || !sku || !where) {
            return;
        }

        if (sku !== 'no_products') {
            sku = helper.getFormatSku(sku);
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '119',
            'eventname': 'store_locator_page_details',
            'action': action,
            'store': storeName,
            'product_id': sku,
            'type': where
        };

        helper.log('Pushing store result action for ' + location + '!', true);
        helper.push(pushObject);
    }
};
